import styled from 'styled-components';

export const StyledTemplateBanner = styled.div`
  border-top: 1px solid var(--border-color);
  ${'' /* background-color: var(--muted); */}
  padding: 6rem 4rem;
  padding-bottom: 4rem;
  display: grid;
  ${'' /* grid-template-rows: 1fr 6fr 3fr; */}
  align-items: center;
  grid-gap: 1rem;
  place-content: center;
  text-align: center;
  h1 {
    font-size: 5.5rem;
    line-height: 5rem;
    margin: 0;
    padding-bottom: 2rem;
    font-weight: 800;
    letter-spacing: 2px;
    /* Fallback: Set a background color. */
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  .lead {
    font-size: 2rem;
    line-height: 2.5rem;
    ${'' /* color: var(--muted-strong); */}
    opacity: 0.9;
    font-weight: 500;
    padding-bottom: 0.5rem;
  }
  .gradient-primary {
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
  }
  .gradient-text {
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xxl}) {
    h1 {
      font-size: 5.5rem;
      line-height: 5rem;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xl}) {
    grid-template-columns: 1fr;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }
    padding-top: 4rem;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    padding: 3rem 3rem;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }

    h1 {
      font-size: 5rem;
      line-height: 4rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    padding: 1.5rem 2rem;
    h1 {
      font-size: 4rem;
      line-height: 3.5rem;
      text-align: center;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: center;
    }
  }
`;

export const StyledTemplateGrid = styled.div`
  margin-top: -3rem;
  padding: 0rem 4rem;
  align-items: center;
  position: relative;
  h2 {
    font-size: 2.5rem;
    margin: 0;
  }
  p,
  ul,
  ol {
    font-size: 1.175rem;
    line-height: 2rem;
    word-break: break-word;
  }
  .grid-filter {
    padding-bottom: 2rem;
    text-align: center;
    display: grid;
    grid-template-columns: 65px 2px auto;
    grid-gap: 0.5rem;
    align-items: center;
    align-content: center;
    place-content: center;
    position: relative;
    button {
      padding: 0.5rem 0.875rem;
      background-color: var(--white);
      border: 1px solid var(--muted-strong);
      &:hover {
        ${'' /* background-color: var(--muted); */}
        border-color: var(--blue);
        color: var(--blue);
      }
      &[data-active='true'] {
        color: var(--white);
        background-color: var(--blue);
        border-color: var(--blue);
        &:hover {
          border-color: var(--blue-hover);
          background-color: var(--blue-hover);
        }
      }
    }
    .all-filter {
    }
    .divider {
      background-color: var(--muted-strong);
      height: 85%;
      width: 100%;
    }
    .categories {
      text-align: center;
      display: grid;
      grid-template-columns: repeat(5, auto);
      grid-gap: 0.5rem;
      align-items: center;
      align-content: center;
      place-content: center;
    }
  }
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.lg}) {
    padding: 0rem 2rem;
    .grid-container {
      grid-template-columns: 1fr 1fr;
      padding-bottom: 1rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    margin-top: -2rem;
    .grid-filter {
      grid-template-columns: 1fr;
      grid-gap: 1rem;
      .divider {
        height: 2px;
        width: 50%;
        margin: 0 auto;
      }
      .categories {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    .grid-container {
      grid-template-columns: 1fr;
      padding-bottom: 1rem;
    }
  }
`;
